import { createAction } from 'typesafe-actions';

export const helpersModeActions = {
  setHelpersMode: createAction('@helpersMode/set', action => (enabled: boolean) => action(enabled))
};
